import styled from "@emotion/styled";
import LinearProgress, {
	linearProgressClasses,
} from "@mui/material/LinearProgress";

const BorderLinearProgress = styled(LinearProgress)(() => ({
	height: 10,
	borderRadius: 5,
	[`&.${linearProgressClasses.colorPrimary}`]: {},
	[`& .${linearProgressClasses.bar}`]: {
		borderRadius: 5,
	},
}));

export default BorderLinearProgress;
